import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useAcceptUserAccessRequestCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.AcceptUserAccessRequestCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedAcceptUserAccessRequestCommandV1: result.authorized,
		acceptUserAccessRequestCommandV1: result.command,
		completedAcceptUserAccessRequestCommandV1: result.completed,
		errorAcceptUserAccessRequestCommandV1: result.error,
		invokeAcceptUserAccessRequestCommandV1: result.invoke,
		invokingAcceptUserAccessRequestCommandV1: result.invoking,
		succeedAcceptUserAccessRequestCommandV1: result.succeed,
		validationErrorsAcceptUserAccessRequestCommandV1: result.validationErrors,
		onSucceedAcceptUserAccessRequestCommandV1: result.onSucceed,
	}
}

export function useAssignBusinessUserRoleCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.AssignBusinessUserRoleCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedAssignBusinessUserRoleCommandV1: result.authorized,
		assignBusinessUserRoleCommandV1: result.command,
		completedAssignBusinessUserRoleCommandV1: result.completed,
		errorAssignBusinessUserRoleCommandV1: result.error,
		invokeAssignBusinessUserRoleCommandV1: result.invoke,
		invokingAssignBusinessUserRoleCommandV1: result.invoking,
		succeedAssignBusinessUserRoleCommandV1: result.succeed,
		validationErrorsAssignBusinessUserRoleCommandV1: result.validationErrors,
		onSucceedAssignBusinessUserRoleCommandV1: result.onSucceed,
	}
}

export function useAssignGlobalAdminRoleCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.AssignGlobalAdminRoleCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedAssignGlobalAdminRoleCommandV1: result.authorized,
		assignGlobalAdminRoleCommandV1: result.command,
		completedAssignGlobalAdminRoleCommandV1: result.completed,
		errorAssignGlobalAdminRoleCommandV1: result.error,
		invokeAssignGlobalAdminRoleCommandV1: result.invoke,
		invokingAssignGlobalAdminRoleCommandV1: result.invoking,
		succeedAssignGlobalAdminRoleCommandV1: result.succeed,
		validationErrorsAssignGlobalAdminRoleCommandV1: result.validationErrors,
		onSucceedAssignGlobalAdminRoleCommandV1: result.onSucceed,
	}
}

export function useAssignOrganizationAdminRoleCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.AssignOrganizationAdminRoleCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedAssignOrganizationAdminRoleCommandV1: result.authorized,
		assignOrganizationAdminRoleCommandV1: result.command,
		completedAssignOrganizationAdminRoleCommandV1: result.completed,
		errorAssignOrganizationAdminRoleCommandV1: result.error,
		invokeAssignOrganizationAdminRoleCommandV1: result.invoke,
		invokingAssignOrganizationAdminRoleCommandV1: result.invoking,
		succeedAssignOrganizationAdminRoleCommandV1: result.succeed,
		validationErrorsAssignOrganizationAdminRoleCommandV1: result.validationErrors,
		onSucceedAssignOrganizationAdminRoleCommandV1: result.onSucceed,
	}
}

export function useAssignWorkspaceUserRoleCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.AssignWorkspaceUserRoleCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedAssignWorkspaceUserRoleCommandV1: result.authorized,
		assignWorkspaceUserRoleCommandV1: result.command,
		completedAssignWorkspaceUserRoleCommandV1: result.completed,
		errorAssignWorkspaceUserRoleCommandV1: result.error,
		invokeAssignWorkspaceUserRoleCommandV1: result.invoke,
		invokingAssignWorkspaceUserRoleCommandV1: result.invoking,
		succeedAssignWorkspaceUserRoleCommandV1: result.succeed,
		validationErrorsAssignWorkspaceUserRoleCommandV1: result.validationErrors,
		onSucceedAssignWorkspaceUserRoleCommandV1: result.onSucceed,
	}
}

export function useChangeOrganizationUnitCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: number | Ref<number> | (() => number), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<number>(organizationUnitId) ? organizationUnitId : ref<number>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }

			return new c.ChangeOrganizationUnitCommandV1(_id.value, _organizationUnitId.value)
		})
	}

	return {
		...result,
		authorizedChangeOrganizationUnitCommandV1: result.authorized,
		changeOrganizationUnitCommandV1: result.command,
		completedChangeOrganizationUnitCommandV1: result.completed,
		errorChangeOrganizationUnitCommandV1: result.error,
		invokeChangeOrganizationUnitCommandV1: result.invoke,
		invokingChangeOrganizationUnitCommandV1: result.invoking,
		succeedChangeOrganizationUnitCommandV1: result.succeed,
		validationErrorsChangeOrganizationUnitCommandV1: result.validationErrors,
		onSucceedChangeOrganizationUnitCommandV1: result.onSucceed,
	}
}

export function useChangePasswordCommandV1(
	id?: string | Ref<string> | (() => string), 
	password?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _password = isRef<string>(password) ? password : ref<string>((typeof password === 'function') ? password() : password)

	const result = {
		id: _id,
		password: _password,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof password === 'function') { _password.value = password() }

			return new c.ChangePasswordCommandV1(_id.value, _password.value)
		})
	}

	return {
		...result,
		authorizedChangePasswordCommandV1: result.authorized,
		changePasswordCommandV1: result.command,
		completedChangePasswordCommandV1: result.completed,
		errorChangePasswordCommandV1: result.error,
		invokeChangePasswordCommandV1: result.invoke,
		invokingChangePasswordCommandV1: result.invoking,
		succeedChangePasswordCommandV1: result.succeed,
		validationErrorsChangePasswordCommandV1: result.validationErrors,
		onSucceedChangePasswordCommandV1: result.onSucceed,
	}
}

export function useCreateServiceUserCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: number | null | Ref<number | null> | (() => number | null), 
	email?: string | Ref<string> | (() => string), 
	displayName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<number | null>(organizationUnitId) ? organizationUnitId : ref<number | null>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _email = isRef<string>(email) ? email : ref<string>((typeof email === 'function') ? email() : email)
	const _displayName = isRef<string>(displayName) ? displayName : ref<string>((typeof displayName === 'function') ? displayName() : displayName)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		email: _email,
		displayName: _displayName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof email === 'function') { _email.value = email() }
			if (typeof displayName === 'function') { _displayName.value = displayName() }

			return new c.CreateServiceUserCommandV1(_id.value, _organizationUnitId.value, _email.value, _displayName.value)
		})
	}

	return {
		...result,
		authorizedCreateServiceUserCommandV1: result.authorized,
		createServiceUserCommandV1: result.command,
		completedCreateServiceUserCommandV1: result.completed,
		errorCreateServiceUserCommandV1: result.error,
		invokeCreateServiceUserCommandV1: result.invoke,
		invokingCreateServiceUserCommandV1: result.invoking,
		succeedCreateServiceUserCommandV1: result.succeed,
		validationErrorsCreateServiceUserCommandV1: result.validationErrors,
		onSucceedCreateServiceUserCommandV1: result.onSucceed,
	}
}

export function useCreateUserCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: number | null | Ref<number | null> | (() => number | null), 
	email?: string | Ref<string> | (() => string), 
	firstName?: string | Ref<string> | (() => string), 
	lastName?: string | Ref<string> | (() => string), 
	isGlobalAdmin?: boolean | Ref<boolean> | (() => boolean), 
	isOrganizationAdmin?: boolean | Ref<boolean> | (() => boolean), 
	isWorkspaceUser?: boolean | Ref<boolean> | (() => boolean), 
	isBusinessUser?: boolean | Ref<boolean> | (() => boolean), 
	setInitialPassword?: boolean | Ref<boolean> | (() => boolean), 
	password?: string | null | Ref<string | null> | (() => string | null), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<number | null>(organizationUnitId) ? organizationUnitId : ref<number | null>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _email = isRef<string>(email) ? email : ref<string>((typeof email === 'function') ? email() : email)
	const _firstName = isRef<string>(firstName) ? firstName : ref<string>((typeof firstName === 'function') ? firstName() : firstName)
	const _lastName = isRef<string>(lastName) ? lastName : ref<string>((typeof lastName === 'function') ? lastName() : lastName)
	const _isGlobalAdmin = isRef<boolean>(isGlobalAdmin) ? isGlobalAdmin : ref<boolean>((typeof isGlobalAdmin === 'function') ? isGlobalAdmin() : isGlobalAdmin)
	const _isOrganizationAdmin = isRef<boolean>(isOrganizationAdmin) ? isOrganizationAdmin : ref<boolean>((typeof isOrganizationAdmin === 'function') ? isOrganizationAdmin() : isOrganizationAdmin)
	const _isWorkspaceUser = isRef<boolean>(isWorkspaceUser) ? isWorkspaceUser : ref<boolean>((typeof isWorkspaceUser === 'function') ? isWorkspaceUser() : isWorkspaceUser)
	const _isBusinessUser = isRef<boolean>(isBusinessUser) ? isBusinessUser : ref<boolean>((typeof isBusinessUser === 'function') ? isBusinessUser() : isBusinessUser)
	const _setInitialPassword = isRef<boolean>(setInitialPassword) ? setInitialPassword : ref<boolean>((typeof setInitialPassword === 'function') ? setInitialPassword() : setInitialPassword)
	const _password = isRef<string | null>(password) ? password : ref<string | null>((typeof password === 'function') ? password() : password)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		email: _email,
		firstName: _firstName,
		lastName: _lastName,
		isGlobalAdmin: _isGlobalAdmin,
		isOrganizationAdmin: _isOrganizationAdmin,
		isWorkspaceUser: _isWorkspaceUser,
		isBusinessUser: _isBusinessUser,
		setInitialPassword: _setInitialPassword,
		password: _password,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof email === 'function') { _email.value = email() }
			if (typeof firstName === 'function') { _firstName.value = firstName() }
			if (typeof lastName === 'function') { _lastName.value = lastName() }
			if (typeof isGlobalAdmin === 'function') { _isGlobalAdmin.value = isGlobalAdmin() }
			if (typeof isOrganizationAdmin === 'function') { _isOrganizationAdmin.value = isOrganizationAdmin() }
			if (typeof isWorkspaceUser === 'function') { _isWorkspaceUser.value = isWorkspaceUser() }
			if (typeof isBusinessUser === 'function') { _isBusinessUser.value = isBusinessUser() }
			if (typeof setInitialPassword === 'function') { _setInitialPassword.value = setInitialPassword() }
			if (typeof password === 'function') { _password.value = password() }

			return new c.CreateUserCommandV1(_id.value, _organizationUnitId.value, _email.value, _firstName.value, _lastName.value, _isGlobalAdmin.value, _isOrganizationAdmin.value, _isWorkspaceUser.value, _isBusinessUser.value, _setInitialPassword.value, _password.value)
		})
	}

	return {
		...result,
		authorizedCreateUserCommandV1: result.authorized,
		createUserCommandV1: result.command,
		completedCreateUserCommandV1: result.completed,
		errorCreateUserCommandV1: result.error,
		invokeCreateUserCommandV1: result.invoke,
		invokingCreateUserCommandV1: result.invoking,
		succeedCreateUserCommandV1: result.succeed,
		validationErrorsCreateUserCommandV1: result.validationErrors,
		onSucceedCreateUserCommandV1: result.onSucceed,
	}
}

export function useDisableUserCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.DisableUserCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedDisableUserCommandV1: result.authorized,
		disableUserCommandV1: result.command,
		completedDisableUserCommandV1: result.completed,
		errorDisableUserCommandV1: result.error,
		invokeDisableUserCommandV1: result.invoke,
		invokingDisableUserCommandV1: result.invoking,
		succeedDisableUserCommandV1: result.succeed,
		validationErrorsDisableUserCommandV1: result.validationErrors,
		onSucceedDisableUserCommandV1: result.onSucceed,
	}
}

export function useEnableUserCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.EnableUserCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedEnableUserCommandV1: result.authorized,
		enableUserCommandV1: result.command,
		completedEnableUserCommandV1: result.completed,
		errorEnableUserCommandV1: result.error,
		invokeEnableUserCommandV1: result.invoke,
		invokingEnableUserCommandV1: result.invoking,
		succeedEnableUserCommandV1: result.succeed,
		validationErrorsEnableUserCommandV1: result.validationErrors,
		onSucceedEnableUserCommandV1: result.onSucceed,
	}
}

export function useLockUserCommandV1(
	id?: string | Ref<string> | (() => string), 
	reason?: string | Ref<string> | (() => string), 
	unlockAt?: any | null | Ref<any | null> | (() => any | null), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _reason = isRef<string>(reason) ? reason : ref<string>((typeof reason === 'function') ? reason() : reason)
	const _unlockAt = isRef<any | null>(unlockAt) ? unlockAt : ref<any | null>((typeof unlockAt === 'function') ? unlockAt() : unlockAt)

	const result = {
		id: _id,
		reason: _reason,
		unlockAt: _unlockAt,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof reason === 'function') { _reason.value = reason() }
			if (typeof unlockAt === 'function') { _unlockAt.value = unlockAt() }

			return new c.LockUserCommandV1(_id.value, _reason.value, _unlockAt.value)
		})
	}

	return {
		...result,
		authorizedLockUserCommandV1: result.authorized,
		lockUserCommandV1: result.command,
		completedLockUserCommandV1: result.completed,
		errorLockUserCommandV1: result.error,
		invokeLockUserCommandV1: result.invoke,
		invokingLockUserCommandV1: result.invoking,
		succeedLockUserCommandV1: result.succeed,
		validationErrorsLockUserCommandV1: result.validationErrors,
		onSucceedLockUserCommandV1: result.onSucceed,
	}
}

export function useRejectUserAccessRequestCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.RejectUserAccessRequestCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedRejectUserAccessRequestCommandV1: result.authorized,
		rejectUserAccessRequestCommandV1: result.command,
		completedRejectUserAccessRequestCommandV1: result.completed,
		errorRejectUserAccessRequestCommandV1: result.error,
		invokeRejectUserAccessRequestCommandV1: result.invoke,
		invokingRejectUserAccessRequestCommandV1: result.invoking,
		succeedRejectUserAccessRequestCommandV1: result.succeed,
		validationErrorsRejectUserAccessRequestCommandV1: result.validationErrors,
		onSucceedRejectUserAccessRequestCommandV1: result.onSucceed,
	}
}

export function useRequestResetPasswordCommandV1(
	email?: string | Ref<string> | (() => string), 
) 
{
	const _email = isRef<string>(email) ? email : ref<string>((typeof email === 'function') ? email() : email)

	const result = {
		email: _email,

		...useCommand(() => {
			if (typeof email === 'function') { _email.value = email() }

			return new c.RequestResetPasswordCommandV1(_email.value)
		})
	}

	return {
		...result,
		authorizedRequestResetPasswordCommandV1: result.authorized,
		requestResetPasswordCommandV1: result.command,
		completedRequestResetPasswordCommandV1: result.completed,
		errorRequestResetPasswordCommandV1: result.error,
		invokeRequestResetPasswordCommandV1: result.invoke,
		invokingRequestResetPasswordCommandV1: result.invoking,
		succeedRequestResetPasswordCommandV1: result.succeed,
		validationErrorsRequestResetPasswordCommandV1: result.validationErrors,
		onSucceedRequestResetPasswordCommandV1: result.onSucceed,
	}
}

export function useRequestSsoUrlCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.RequestSsoUrlCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedRequestSsoUrlCommandV1: result.authorized,
		requestSsoUrlCommandV1: result.command,
		completedRequestSsoUrlCommandV1: result.completed,
		errorRequestSsoUrlCommandV1: result.error,
		invokeRequestSsoUrlCommandV1: result.invoke,
		invokingRequestSsoUrlCommandV1: result.invoking,
		succeedRequestSsoUrlCommandV1: result.succeed,
		validationErrorsRequestSsoUrlCommandV1: result.validationErrors,
		onSucceedRequestSsoUrlCommandV1: result.onSucceed,
	}
}

export function useRequestUserAccessCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: number | Ref<number> | (() => number), 
	requestedBy?: string | Ref<string> | (() => string), 
	email?: string | Ref<string> | (() => string), 
	firstName?: string | Ref<string> | (() => string), 
	lastName?: string | Ref<string> | (() => string), 
	displayName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<number>(organizationUnitId) ? organizationUnitId : ref<number>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _requestedBy = isRef<string>(requestedBy) ? requestedBy : ref<string>((typeof requestedBy === 'function') ? requestedBy() : requestedBy)
	const _email = isRef<string>(email) ? email : ref<string>((typeof email === 'function') ? email() : email)
	const _firstName = isRef<string>(firstName) ? firstName : ref<string>((typeof firstName === 'function') ? firstName() : firstName)
	const _lastName = isRef<string>(lastName) ? lastName : ref<string>((typeof lastName === 'function') ? lastName() : lastName)
	const _displayName = isRef<string>(displayName) ? displayName : ref<string>((typeof displayName === 'function') ? displayName() : displayName)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		requestedBy: _requestedBy,
		email: _email,
		firstName: _firstName,
		lastName: _lastName,
		displayName: _displayName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof requestedBy === 'function') { _requestedBy.value = requestedBy() }
			if (typeof email === 'function') { _email.value = email() }
			if (typeof firstName === 'function') { _firstName.value = firstName() }
			if (typeof lastName === 'function') { _lastName.value = lastName() }
			if (typeof displayName === 'function') { _displayName.value = displayName() }

			return new c.RequestUserAccessCommandV1(_id.value, _organizationUnitId.value, _requestedBy.value, _email.value, _firstName.value, _lastName.value, _displayName.value)
		})
	}

	return {
		...result,
		authorizedRequestUserAccessCommandV1: result.authorized,
		requestUserAccessCommandV1: result.command,
		completedRequestUserAccessCommandV1: result.completed,
		errorRequestUserAccessCommandV1: result.error,
		invokeRequestUserAccessCommandV1: result.invoke,
		invokingRequestUserAccessCommandV1: result.invoking,
		succeedRequestUserAccessCommandV1: result.succeed,
		validationErrorsRequestUserAccessCommandV1: result.validationErrors,
		onSucceedRequestUserAccessCommandV1: result.onSucceed,
	}
}

export function useResetPasswordCommandV1(
	id?: string | Ref<string> | (() => string), 
	sendPasswordToEmail?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _sendPasswordToEmail = isRef<string>(sendPasswordToEmail) ? sendPasswordToEmail : ref<string>((typeof sendPasswordToEmail === 'function') ? sendPasswordToEmail() : sendPasswordToEmail)

	const result = {
		id: _id,
		sendPasswordToEmail: _sendPasswordToEmail,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof sendPasswordToEmail === 'function') { _sendPasswordToEmail.value = sendPasswordToEmail() }

			return new c.ResetPasswordCommandV1(_id.value, _sendPasswordToEmail.value)
		})
	}

	return {
		...result,
		authorizedResetPasswordCommandV1: result.authorized,
		resetPasswordCommandV1: result.command,
		completedResetPasswordCommandV1: result.completed,
		errorResetPasswordCommandV1: result.error,
		invokeResetPasswordCommandV1: result.invoke,
		invokingResetPasswordCommandV1: result.invoking,
		succeedResetPasswordCommandV1: result.succeed,
		validationErrorsResetPasswordCommandV1: result.validationErrors,
		onSucceedResetPasswordCommandV1: result.onSucceed,
	}
}

export function useRevokeBusinessUserRoleCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.RevokeBusinessUserRoleCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedRevokeBusinessUserRoleCommandV1: result.authorized,
		revokeBusinessUserRoleCommandV1: result.command,
		completedRevokeBusinessUserRoleCommandV1: result.completed,
		errorRevokeBusinessUserRoleCommandV1: result.error,
		invokeRevokeBusinessUserRoleCommandV1: result.invoke,
		invokingRevokeBusinessUserRoleCommandV1: result.invoking,
		succeedRevokeBusinessUserRoleCommandV1: result.succeed,
		validationErrorsRevokeBusinessUserRoleCommandV1: result.validationErrors,
		onSucceedRevokeBusinessUserRoleCommandV1: result.onSucceed,
	}
}

export function useRevokeGlobalAdminRoleCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.RevokeGlobalAdminRoleCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedRevokeGlobalAdminRoleCommandV1: result.authorized,
		revokeGlobalAdminRoleCommandV1: result.command,
		completedRevokeGlobalAdminRoleCommandV1: result.completed,
		errorRevokeGlobalAdminRoleCommandV1: result.error,
		invokeRevokeGlobalAdminRoleCommandV1: result.invoke,
		invokingRevokeGlobalAdminRoleCommandV1: result.invoking,
		succeedRevokeGlobalAdminRoleCommandV1: result.succeed,
		validationErrorsRevokeGlobalAdminRoleCommandV1: result.validationErrors,
		onSucceedRevokeGlobalAdminRoleCommandV1: result.onSucceed,
	}
}

export function useRevokeOrganizationAdminRoleCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.RevokeOrganizationAdminRoleCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedRevokeOrganizationAdminRoleCommandV1: result.authorized,
		revokeOrganizationAdminRoleCommandV1: result.command,
		completedRevokeOrganizationAdminRoleCommandV1: result.completed,
		errorRevokeOrganizationAdminRoleCommandV1: result.error,
		invokeRevokeOrganizationAdminRoleCommandV1: result.invoke,
		invokingRevokeOrganizationAdminRoleCommandV1: result.invoking,
		succeedRevokeOrganizationAdminRoleCommandV1: result.succeed,
		validationErrorsRevokeOrganizationAdminRoleCommandV1: result.validationErrors,
		onSucceedRevokeOrganizationAdminRoleCommandV1: result.onSucceed,
	}
}

export function useRevokeServiceUserFlagCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.RevokeServiceUserFlagCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedRevokeServiceUserFlagCommandV1: result.authorized,
		revokeServiceUserFlagCommandV1: result.command,
		completedRevokeServiceUserFlagCommandV1: result.completed,
		errorRevokeServiceUserFlagCommandV1: result.error,
		invokeRevokeServiceUserFlagCommandV1: result.invoke,
		invokingRevokeServiceUserFlagCommandV1: result.invoking,
		succeedRevokeServiceUserFlagCommandV1: result.succeed,
		validationErrorsRevokeServiceUserFlagCommandV1: result.validationErrors,
		onSucceedRevokeServiceUserFlagCommandV1: result.onSucceed,
	}
}

export function useRevokeWorkspaceUserRoleCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.RevokeWorkspaceUserRoleCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedRevokeWorkspaceUserRoleCommandV1: result.authorized,
		revokeWorkspaceUserRoleCommandV1: result.command,
		completedRevokeWorkspaceUserRoleCommandV1: result.completed,
		errorRevokeWorkspaceUserRoleCommandV1: result.error,
		invokeRevokeWorkspaceUserRoleCommandV1: result.invoke,
		invokingRevokeWorkspaceUserRoleCommandV1: result.invoking,
		succeedRevokeWorkspaceUserRoleCommandV1: result.succeed,
		validationErrorsRevokeWorkspaceUserRoleCommandV1: result.validationErrors,
		onSucceedRevokeWorkspaceUserRoleCommandV1: result.onSucceed,
	}
}

export function useSignInCommandV1(
	id?: string | Ref<string> | (() => string), 
	password?: string | Ref<string> | (() => string), 
	returnUrl?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _password = isRef<string>(password) ? password : ref<string>((typeof password === 'function') ? password() : password)
	const _returnUrl = isRef<string>(returnUrl) ? returnUrl : ref<string>((typeof returnUrl === 'function') ? returnUrl() : returnUrl)

	const result = {
		id: _id,
		password: _password,
		returnUrl: _returnUrl,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof password === 'function') { _password.value = password() }
			if (typeof returnUrl === 'function') { _returnUrl.value = returnUrl() }

			return new c.SignInCommandV1(_id.value, _password.value, _returnUrl.value)
		})
	}

	return {
		...result,
		authorizedSignInCommandV1: result.authorized,
		signInCommandV1: result.command,
		completedSignInCommandV1: result.completed,
		errorSignInCommandV1: result.error,
		invokeSignInCommandV1: result.invoke,
		invokingSignInCommandV1: result.invoking,
		succeedSignInCommandV1: result.succeed,
		validationErrorsSignInCommandV1: result.validationErrors,
		onSucceedSignInCommandV1: result.onSucceed,
	}
}

export function useSignoutFromAllSessionsCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.SignoutFromAllSessionsCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedSignoutFromAllSessionsCommandV1: result.authorized,
		signoutFromAllSessionsCommandV1: result.command,
		completedSignoutFromAllSessionsCommandV1: result.completed,
		errorSignoutFromAllSessionsCommandV1: result.error,
		invokeSignoutFromAllSessionsCommandV1: result.invoke,
		invokingSignoutFromAllSessionsCommandV1: result.invoking,
		succeedSignoutFromAllSessionsCommandV1: result.succeed,
		validationErrorsSignoutFromAllSessionsCommandV1: result.validationErrors,
		onSucceedSignoutFromAllSessionsCommandV1: result.onSucceed,
	}
}

export function useSignoutFromSessionCommandV1(
	id?: string | Ref<string> | (() => string), 
	sessionId?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _sessionId = isRef<string>(sessionId) ? sessionId : ref<string>((typeof sessionId === 'function') ? sessionId() : sessionId)

	const result = {
		id: _id,
		sessionId: _sessionId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof sessionId === 'function') { _sessionId.value = sessionId() }

			return new c.SignoutFromSessionCommandV1(_id.value, _sessionId.value)
		})
	}

	return {
		...result,
		authorizedSignoutFromSessionCommandV1: result.authorized,
		signoutFromSessionCommandV1: result.command,
		completedSignoutFromSessionCommandV1: result.completed,
		errorSignoutFromSessionCommandV1: result.error,
		invokeSignoutFromSessionCommandV1: result.invoke,
		invokingSignoutFromSessionCommandV1: result.invoking,
		succeedSignoutFromSessionCommandV1: result.succeed,
		validationErrorsSignoutFromSessionCommandV1: result.validationErrors,
		onSucceedSignoutFromSessionCommandV1: result.onSucceed,
	}
}

export function useUnlockUserCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.UnlockUserCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedUnlockUserCommandV1: result.authorized,
		unlockUserCommandV1: result.command,
		completedUnlockUserCommandV1: result.completed,
		errorUnlockUserCommandV1: result.error,
		invokeUnlockUserCommandV1: result.invoke,
		invokingUnlockUserCommandV1: result.invoking,
		succeedUnlockUserCommandV1: result.succeed,
		validationErrorsUnlockUserCommandV1: result.validationErrors,
		onSucceedUnlockUserCommandV1: result.onSucceed,
	}
}

export function useUpdateUserDetailsCommandV1(
	id?: string | Ref<string> | (() => string), 
	firstName?: string | Ref<string> | (() => string), 
	lastName?: string | Ref<string> | (() => string), 
	displayName?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _firstName = isRef<string>(firstName) ? firstName : ref<string>((typeof firstName === 'function') ? firstName() : firstName)
	const _lastName = isRef<string>(lastName) ? lastName : ref<string>((typeof lastName === 'function') ? lastName() : lastName)
	const _displayName = isRef<string>(displayName) ? displayName : ref<string>((typeof displayName === 'function') ? displayName() : displayName)

	const result = {
		id: _id,
		firstName: _firstName,
		lastName: _lastName,
		displayName: _displayName,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof firstName === 'function') { _firstName.value = firstName() }
			if (typeof lastName === 'function') { _lastName.value = lastName() }
			if (typeof displayName === 'function') { _displayName.value = displayName() }

			return new c.UpdateUserDetailsCommandV1(_id.value, _firstName.value, _lastName.value, _displayName.value)
		})
	}

	return {
		...result,
		authorizedUpdateUserDetailsCommandV1: result.authorized,
		updateUserDetailsCommandV1: result.command,
		completedUpdateUserDetailsCommandV1: result.completed,
		errorUpdateUserDetailsCommandV1: result.error,
		invokeUpdateUserDetailsCommandV1: result.invoke,
		invokingUpdateUserDetailsCommandV1: result.invoking,
		succeedUpdateUserDetailsCommandV1: result.succeed,
		validationErrorsUpdateUserDetailsCommandV1: result.validationErrors,
		onSucceedUpdateUserDetailsCommandV1: result.onSucceed,
	}
}

